import { ref } from 'vue';
// TODO: also update help center auth (?)
// code in sync with help/docs/.vuepress/auth.js

const instance = ref(null);
class Auth {
  is_authenticated = ref(false);

  constructor() {
    instance.value = this;
  }
}
export const getInstance = () => instance.value;

export const AuthPlugin = {
  install(app, options) {
    // TODO @david linter maybe it can just be
    // app.config.globalProperties.$auth = new Auth(options);
    // oxlint-disable-next-line no-new
    new Auth(options);
    app.config.globalProperties.$auth = instance.value;
  },
};
